<template>
	<span class="ks-badge" :class="classes">
		<slot></slot>
		<span v-if="showBadge" class="ks-badge-badge" :class="badgeClasses" :style="badgeStyle">
			<slot name="badge">{{ content }}</slot>
		</span>
	</span>
</template>

<script>
export default {
	props: {
		"color": {
			type: String,
			default: "info"
		},
		"overlap": {
			type: Boolean,
			default: false
		},
		"left": {
			type: Boolean,
			default: false
		},
		"bottom": {
			type: Boolean,
			default: false
		},
		"dot": {
			type: Boolean,
			default: false
		},
		"value": {
			type: Boolean,
			default: true
		},
		"content": {
			type: [String, Number],
			default: ""
		},
		"inline": {
			type: Boolean,
			default: false
		}
	},
	computed: {
		"classes" () {
			return {
				"ks-badge-inline": this.inline,
				"ks-badge-overlap": this.overlap,
				"ks-badge-left": this.left,
				"ks-badge-bottom": this.bottom,
				"ks-badge-dot": this.dot
			}
		},
		"badgeClasses" () {
			var ret = {}
			if (this.color) {
				ret["ks-badge-" + this.color] = true
			}
			return ret
		},
		"badgeStyle" () {
			var style = {}
			if (this.color && !this.colorIsClass(this.color)) {
				style.backgroundColor = this.color
			}
			return style
		},
		"showBadge" () {
			if (!this.value) return false
			if (this.dot) return true
			if (this.content !== "" && this.content !== undefined && this.content !== null) return true
			if (this.$slots.badge) return true
			return false
		}
	},
	methods: {
		colorIsClass (color) {
			var named = ["accent", "success", "danger", "warning", "info", "white", "light-grey"]
			return named.indexOf(color) !== -1
		}
	}
}
</script>

<style scoped>
.ks-badge {
	position: relative;
	isolation: isolate;
	display: inline-flex;
	align-items: center;
	vertical-align: middle;
	overflow: visible;
}

.ks-badge-badge {
	position: absolute;
	top: -4px;
	right: -4px;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 16px;
	height: 16px;
	padding: 0 4px;
	border-radius: 10px;
	font-size: 10px;
	font-weight: 500;
	color: var(--ks-font-color);
	background-color: var(--ks-col-info);
	line-height: 1;
	pointer-events: none;
	white-space: nowrap;
	opacity: 0.8;
}

.ks-badge-inline {
	position: static;
	display: inline-flex;
	align-items: center;
}

.ks-badge-inline .ks-badge-badge {
	position: static;
	margin-left: 4px;
}

.ks-badge-overlap .ks-badge-badge {
	top: -4px;
	right: -8px;
}

.ks-badge-left .ks-badge-badge {
	right: auto;
	left: -4px;
}

.ks-badge-left.ks-badge-overlap .ks-badge-badge {
	left: -8px;
}

.ks-badge-bottom .ks-badge-badge {
	top: auto;
	bottom: -4px;
}

.ks-badge-bottom.ks-badge-overlap .ks-badge-badge {
	bottom: -8px;
}

.ks-badge-dot .ks-badge-badge {
	min-width: 10px;
	height: 10px;
	padding: 0;
	border-radius: 50%;
	font-size: 0;
}

/* Color classes */
.ks-badge-accent {
	background-color: var(--ks-col-accent, #1976d2);
	color: #000;
}

.ks-badge-success {
	background-color: var(--ks-col-success, #4caf50);
}

.ks-badge-danger {
	background-color: var(--ks-col-danger, #ff5252);
}

.ks-badge-warning {
	background-color: var(--ks-col-warning, #fb8c00);
}

.ks-badge-info {
	background-color: var(--ks-col-info, #2196f3);
}
</style>

<style>
/* Allow badge to overflow parent containers like k-btn */
.ks-btn:has(.ks-badge) {
	overflow: visible;
}
</style>
